import {
  Box, List,
  ListItem,
  SvgIconProps,
  Typography,
  Stack
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { isNavRouteActive } from "@components/custom-components/master-layout/side-navigation-items/workspace/isNavRouteActive";
import NavigationItems from "@components/custom-components/navigation/NavigationItems";

import React, { useEffect, useState } from "react";
import { startCase } from "lodash";
import superAdminNavigation from "@setup/route_config/superAdminRoutes";
import { NavigationGroup } from "@setup/route_config";
import useDrawerStore from "@setup/store/useDrawerStore";
import { useIsDesktopLayout } from "../../../../hooks/useIsDesktopLayout";

const Workspaces = () => {
  const [activeTab, setActiveTab] = useState("");

  const isMobile = !useIsDesktopLayout();
  const { toggle } = useDrawerStore();

  const { pathname } = useLocation();

  useEffect(() => {
    const current_path = pathname.split("/")[1];
    setActiveTab(current_path);
  }, [pathname]);

  // Close the mobile drawer when the active workspace tab changes; isMobile is
  // read but intentionally not a dep so a resize alone doesn't close the drawer.
  useEffect(() => {
    if (isMobile) toggle(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);
  
  
  return (
    <Stack>
      <List sx={{ pt: 0 }}>
        {(superAdminNavigation as NavigationGroup[]).map((group, ind) => (
          <Box key={ind} mb={2}>
            <ListItem>
              <Typography variant="description" style={{ opacity: 0.5, textTransform: "uppercase" }}>{group.title}</Typography>
            </ListItem>
            {group.routes.map((route) => (
              <NavigationItems
                key={route.path}
                active={isNavRouteActive(route.path, activeTab)}
                icon={
                  route.icon && React.isValidElement(route.icon)
                    ? React.cloneElement(route.icon as React.ReactElement<SvgIconProps>, {
                        color: isNavRouteActive(route.path, activeTab) ? "primary" : undefined,
                      })
                    : null
                }
                label={startCase(route.label)}
                link={route.path ?? "/"}
              />
            ))}
          </Box>
        ))}
      </List>
    </Stack>
  );
};

export default Workspaces;
